import * as React from 'react';
import { EditViewProps } from "../interfaces";
import ButtonData from "./ModuleData";
import l10n from "diy/util/l10n";
import IconTextButton from 'diy/custom-components/icon-text-button/IconTextButton';
import IconTextButtonGroup from 'diy/custom-components/icon-text-button/IconTextButtonGroup';
import TextField from "material-ui/TextField";
import ResponsiveBar from '../../components/ResponsiveBar';
import { autoprefixer } from '../../material-ui/autoprefixer';
import LinkIcon from 'material-ui/svg-icons/content/link';
import LeftAlignIcon from 'material-ui/svg-icons/editor/format-align-left';
import CenterAlignIcon from 'material-ui/svg-icons/editor/format-align-center';
import RightAlignIcon from 'material-ui/svg-icons/editor/format-align-right';

import { ButtonBackgroundColorIcon } from '../../components/color-picker/ButtonBackgroundColorIcon';
import { ButtonTextColorIcon } from '../../components/color-picker/ButtonTextColorIcon';
import { ColorPickerWithLsDropdown } from '../../components/color-picker/ColorPickerWithLsDropdown';

import { PREDEFINED_MODE } from '../../components/color-picker/ColorPicker';

interface ButtonEditViewProps extends EditViewProps<ButtonData>, React.Props<ButtonEditView> {
}

export default class ButtonEditView extends React.Component<ButtonEditViewProps, {}> {

    private alignValues = ["left", "center", "right"];

    private textField: TextField;

    getStyles() {
        return {
            root: autoprefixer({
                display: "flex",
                padding: 4,
                fontSize: "12px",
            }),
            link: {
                marginRight: 24
            },
            button: {
                marginRight: 4
            },
            left: {
                marginRight: "12px",
                alignSelf: "center",
                WebkitAlignSelf: "center",
                fontSize: "12px"
            },
            input: {
                display: "inline-block",
                verticalAlign: "top",
                marginLeft: 24
            }
        };
    }

    render() {
        const styles = this.getStyles();

        return (
            <div style={styles.root}>
                <ResponsiveBar>
                    <IconTextButton
                        style={styles.link}
                        Icon={<LinkIcon />}
                        text={l10n("module.button.link")}
                        dataTestId="btn-module-add-or-edit-link-btn"
                        onTouchTap={this.onLinkClick}
                    />
                    {this.props.payload.supports.buttonAlign ?
                    <IconTextButtonGroup
                        Icon={<LeftAlignIcon />}
                        label={l10n('module.text.buttongroups.align')}
                        dataTestId="button-module-align-menu"
                        isRadio={true}
                        selectedIndex={this.alignValues.indexOf(this.props.payload.align)}
                        onChange={this.onAlignChange}
                    >
                        <IconTextButton
                            Icon={<LeftAlignIcon />}
                            text={l10n("module.button.align.left")}
                            style={styles.button}
                            dataTestId="btn-module-align-left-btn"
                        />
                        <IconTextButton
                            Icon={<CenterAlignIcon />}
                            text={l10n("module.button.align.center")}
                            style={styles.button}
                            dataTestId="btn-module-align-center-btn"
                        />
                        <IconTextButton
                            Icon={<RightAlignIcon />}
                            text={l10n("module.button.align.right")}
                            style={styles.button}
                            dataTestId="btn-module-align-right-btn"
                        />
                    </IconTextButtonGroup>
                    : null}
                    <ColorPickerWithLsDropdown
                        Icon={( <ButtonBackgroundColorIcon /> )}
                        text={l10n('module.button.backgroundColor')}
                        hexColor={
                            this.props.payload.backgroundColor ||
                            this.props.payload.defaultBackgroundColor
                        }
                        initialMode={
                            !this.props.payload.backgroundColor
                                ? PREDEFINED_MODE
                                : null
                        }
                        onChange={this.onBackgroundColorChange}
                    />
                    <ColorPickerWithLsDropdown
                        Icon={( <ButtonTextColorIcon /> )}
                        text={l10n('module.button.textColor')}
                        hexColor={
                            this.props.payload.textColor ||
                            this.props.payload.defaultTextColor
                        }
                        initialMode={
                            !this.props.payload.textColor
                                ? PREDEFINED_MODE
                                : null
                        }
                        onChange={this.onTextColorChange}
                    />
                    <div style={styles.input}>
                        <span style={styles.left}>{l10n("module.button.label")}</span>
                        <TextField
                            data-test-id="btn-module-label-text-field"
                            ref={(ref: TextField) => {this.textField = ref;}}
                            value={this.props.payload.text}
                            onChange={this.onTextChange}
                            id={"btn-module" + this.props.moduleId}
                        />
                    </div>
                </ResponsiveBar>
            </div>
        );
    }

    private onBackgroundColorChange = (hexColor: string, isDefault: boolean) => {
        this.props.onDataChange(Object.assign({}, this.props.payload, {
            backgroundColor: isDefault ? '' : hexColor
        }));
    };

    private onTextColorChange = (hexColor: string, isDefault: boolean) => {
        this.props.onDataChange(Object.assign({}, this.props.payload, {
            textColor: isDefault ? '' : hexColor
        }));
    };

    private onTextChange = () => {
        this.props.onDataChange(
            Object.assign({}, this.props.payload, {
                text:  this.textField.getValue()
            })
        );
    };

    private onAlignChange = (e: React.SyntheticEvent<{}>, value: number) => {
       this.props.onDataChange(
           Object.assign({}, this.props.payload, {
               align: this.alignValues[value]
           })
        );
    };

    private onLinkClick = () => {
         diy.editor.linkSelector.openDialog({
              href: this.props.payload.link
         }, (outputLinkData) => {
            this.props.onDataChange(
            Object.assign({}, this.props.payload, {
                    link:  outputLinkData.href,
                    linkTarget: outputLinkData.target
                })
            );
         });
    };
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/button/EditView.tsx
 **/